module.exports = __webpack_public_path__ + "static/media/Bytt-tutorial-1.547a01bd.mp3";